import { carData } from '@/types';

export async function openDatabase(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open('UserSessionDB', 1);

    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains('sessions')) {
        db.createObjectStore('sessions', { keyPath: 'id' });
      }
    };

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function saveSession(session: {
  id: string;
  token: string;
  user: object;
  expired_at: string;
}): Promise<void> {
  try {
    const db = await openDatabase();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction('sessions', 'readwrite');
      const store = transaction.objectStore('sessions');

      const request = store.put(session);
      request.onsuccess = () => {
        resolve();
      };

      request.onerror = () => {
        reject(request.error);
      };

      // transaction.oncomplete = () => {};

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function saveCar(
  id: string | number,
  session: Record<string, any>
): Promise<void> {
  try {
    const db = await openDatabase();

    return new Promise((resolve, reject) => {
      const transaction = db.transaction('sessions', 'readwrite');
      const store = transaction.objectStore('sessions');

      session = JSON.parse(JSON.stringify(session));
      session.id = id;
      const request = store.put(session);
      request.onsuccess = () => {
        resolve();
      };

      request.onerror = () => {
        reject(request.error);
      };

      // transaction.oncomplete = () => {};

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
}

export async function getSession(id: string | number): Promise<{
  id: string;
  token: string;
  user: object;
  expired_at: string;
} | null> {
  try {
    const db = await openDatabase(); // Открытие базы данных

    return new Promise((resolve, reject) => {
      const transaction = db.transaction('sessions', 'readonly'); // Открытие транзакции
      const store = transaction.objectStore('sessions'); // Получение objectStore
      const request = store.getAll(); // Попытка получить данные с ключом "userSession"

      request.onsuccess = () => {
        resolve(request.result.find((data) => data.id === id) || null); // Возвращаем данные или null
      };

      request.onerror = () => {
        reject(request.error); // Логгируем ошибку
      };

      // transaction.oncomplete = () => {};

      transaction.onerror = () => {
        reject(transaction.error);
      };
    });
  } catch (error) {
    console.log(error);
    throw error;
  }
}
export async function clearSession(): Promise<void> {
  const db = await openDatabase();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction('sessions', 'readwrite');
    const store = transaction.objectStore('sessions');
    const request = store.clear();

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
}
